import { Component } from "react";
import "./ListingContent.scss";
import classNames from "classnames";
import { LISTING_ITEM_TYPES, RESOLUTION } from "app/constants";
import ListingItemCard from "app/pages/Listing/ListingContent/ListingItemCard";
import PropTypes from "prop-types";
import { merchShape, productShape } from "app/utils/propTypes";
import isEqual from "lodash/isEqual";

const rowOnGrid = (allMerchs, currentMerch, isMobile) => {
	const merchsBeforeCurrentMerch = allMerchs.filter(
		merch => merch?.position !== 0 && merch?.position < currentMerch?.position
	);

	const rowPositionWithoutMerchBefore = isMobile
		? currentMerch?.position
		: Math.floor((currentMerch?.position - 1) / 2) + 1;

	return merchsBeforeCurrentMerch?.length > 0
		? rowPositionWithoutMerchBefore + merchsBeforeCurrentMerch?.length
		: rowPositionWithoutMerchBefore;
};

class ListingContent extends Component {
	shouldComponentUpdate(nextProps) {
		const { resolution, orderedListingItems, isAnyListingFilterActive } = this.props;
		const {
			resolution: nextResolution,
			orderedListingItems: nextOrderedListingItems,
			isAnyListingFilterActive: nextIsAnyListingFilterActive,
		} = nextProps;

		if (!isEqual(nextOrderedListingItems, orderedListingItems)) {
			return true;
		}

		if (resolution !== nextResolution) {
			return true;
		}

		if (isAnyListingFilterActive !== nextIsAnyListingFilterActive) {
			return true;
		}

		return false;
	}

	render() {
		const {
			resolution,
			orderedListingItems = [],
			merchsListingItems,
			isAnyListingFilterActive,
		} = this.props;
		const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;
		return (
			<div className="listing-content">
				<div className="listing-content-grid">
					{orderedListingItems.map((listingItem, index) => {
						const itemClass = classNames({
							"listing-content-grid__item": ![
								LISTING_ITEM_TYPES.MERCH_SIMPLE,
								LISTING_ITEM_TYPES.MERCH_CAROUSSEL,
							].includes(listingItem.type),
							"listing-content-grid__item--card": true,
							[`listing-content-grid__item--merchandising-simple-row-${rowOnGrid(
								merchsListingItems,
								listingItem,
								isMobile
							)}`]: listingItem.type === LISTING_ITEM_TYPES.MERCH_SIMPLE,
							[`listing-content-grid__item--merchandising-caroussel-row-${rowOnGrid(
								merchsListingItems,
								listingItem,
								isMobile
							)}`]: listingItem.type === LISTING_ITEM_TYPES.MERCH_CAROUSSEL,
						});

						const key =
							(listingItem.id && `${listingItem.id}${listingItem.startAt}`) ||
							(listingItem.merchandising &&
								(listingItem.merchandising.code ||
									listingItem.merchandising[0].code));

						return !isAnyListingFilterActive ||
							(isAnyListingFilterActive &&
								listingItem.type === LISTING_ITEM_TYPES.PRODUCT) ? (
							<div key={key} className={itemClass}>
								<ListingItemCard
									resolution={resolution}
									hideMerchandising={isAnyListingFilterActive}
									product={listingItem}
									position={index}
								/>
							</div>
						) : (
							false
						);
					})}
				</div>
			</div>
		);
	}
}

ListingContent.propTypes = {
	resolution: PropTypes.string,
	orderedListingItems: PropTypes.arrayOf(PropTypes.oneOfType([merchShape, productShape])),
	merchsListingItems: PropTypes.arrayOf(merchShape),
	isAnyListingFilterActive: PropTypes.bool,
};

export default ListingContent;
